export const user = {
  state: {
    user: undefined,
  },
  reducers: {
    update(state, payload) {
      return { user: { ...payload } };
    },
  },
};
